import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { KEYWORD_CACHE_KEYS } from "./keys";

import { KeywordRepository } from "@/repositories/keyword";
import { KeywordFilters } from "@/types/keyword";

export const useGetAllKeywords = (filters: KeywordFilters) => {
  const keywordRepository = useRef(new KeywordRepository());

  return useQuery({
    queryKey: [KEYWORD_CACHE_KEYS.LIST, filters],
    queryFn: async () => {
      return await keywordRepository.current.findAll(filters);
    },
  });
};
